import { EntityModel } from '@/interfaces'
import {
  ALL_DATES_QUERY,
  CREATE_DATE_MUTATION,
  DELETE_DATE_MUTATION,
  FORCE_DELETE_DATE_MUTATION,
  SINGLE_DATE_QUERY,
  UPDATE_DATE_MUTATION,
} from './graphql'
import { toUiDate } from '@/lib/helpers/helpers'
import travelAvailabilityStatusEntity from '@/entities/travelAvailabilityStatus/entity'
import ratioTravelDateEntity from '@/entities/ratioTravelDate/entity'
import ratioTravelExtensionEntity from '@/entities/ratioTravelExtension/entity'
import ratioDatePackageSettingsEntity from '@/entities/ratioDatePackageSettings/entity'

const ratioTravelDateModel: EntityModel = {
  name: 'date',
  namePlural: 'dates',
  uniqueName: 'ratioTravelDate',
  uniqueNamePlural: 'ratioTravelDates',
  path: 'travel/pricing/adaptors/ratio/date',
  baseUrl: '/travel/pricing/adaptors/ratio/dates',
  translationPrefix: 'entities:ratioTravelDate.',
  getDisplayName: (values: any) => {
    return toUiDate(values.startDate) + ' - ' + toUiDate(values.endDate)
  },
  gql: {
    getAll: ALL_DATES_QUERY,
    getSingle: SINGLE_DATE_QUERY,
    create: CREATE_DATE_MUTATION,
    update: UPDATE_DATE_MUTATION,
    delete: DELETE_DATE_MUTATION,
    forceDelete: FORCE_DELETE_DATE_MUTATION,
  },
  attributes: {
    dateNo: {
      name: 'dateNo',
      label: 'entities:ratioTravelDate.attributes.dateNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    startDate: {
      name: 'startDate',
      label: 'entities:ratioTravelDate.attributes.startDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'date',
      isStartDate: true,
      endDateAttribute: 'endDate',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    endDate: {
      name: 'endDate',
      label: 'entities:ratioTravelDate.attributes.endDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'date',
      isEndDate: true,
      startDateAttribute: 'startDate',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    availabilityStatus: {
      name: 'availabilityStatus',
      label: 'entities:ratioTravelDate.attributes.availabilityStatus.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelAvailabilityStatusEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    isHidden: {
      name: 'isHidden',
      label: 'entities:ratioTravelDate.attributes.isHidden.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    includesExtension: {
      name: 'includesExtension',
      label: 'entities:ratioTravelDate.attributes.includesExtension.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    extensionBaseDate: {
      name: 'extensionBaseDate',
      label: 'entities:ratioTravelDate.attributes.extensionBaseDate.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioTravelDateEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    extension: {
      name: 'extension',
      label: 'entities:ratioTravelDate.attributes.extension.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioTravelExtensionEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    packageSettings: {
      name: 'packageSettings',
      label: 'entities:ratioTravelDate.attributes.packageSettings.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioDatePackageSettingsEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    json: {
      name: 'json',
      label: 'entities:ratioTravelDate.attributes.json.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    extensions: {
      name: 'extensions',
      label: 'entities:ratioTravelDate.attributes.extensions.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioTravelExtensionEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioTravelDateModel
